<template>
    <div>
        <div style="background:#e0e6e7;" class="pl-5 pt-4 pb-2 mb-0">
            <h2 class="page-header">Invalid Request</h2>
        </div>
        <div class="pl-5 mt-5 pt-5">
            <p style="font-size: 1.2em">The link you clicked did not originate from the Switch Telecom Reseller’s website.</p>
            <p style="font-size: 1.2em">Please contact your Switch Telecom Reseller to notify them of the issue or alternatively call Switch Telecom directly on <a href="tel:0875500000" title="Switch Telecom Toll Free Telephone Number" class="text-dark font-weight-bold" target="_blank">087 550 0000</a> for assistance.</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "InvalidReferrer",
  
    mounted() {
 
    },
    data() {
        return {}
           
    }, //end of data

    methods: {
        
    },
};
</script>
